// extracted by mini-css-extract-plugin
export default {"recovery":"RecoveryPassword_recovery__EKQ3a","btnWrapper":"RecoveryPassword_btnWrapper__ElZG4"};